import React from 'react';

function ReviewItem({ author, date, content }) {
  return (
    <article
      className='grid gap-y-2 p-4 border border-white/20 text-[#d9d9d9]'
      itemScope
      itemType='https://schema.org/Review'
      aria-label={`Review by ${author}`}
    >
      <header className='grid'>
        <h3
          className='text-2xl lg:text-3xl font-kugile underline underline-offset-4 font-semibold tracking-wide'
          itemProp='author'
          aria-label='Reviewer'
        >
          {author}
        </h3>
        <time
          className='text-lg'
          itemProp='datePublished'
          aria-label='Review date'
        >
          {date}
        </time>
      </header>

      <blockquote
        className='lg:text-lg leading-relaxed whitespace-pre-line'
        itemProp='reviewBody'
      >
        {content}
      </blockquote>
      <meta itemProp='itemReviewed' content='Mistress Diva' />
    </article>
  );
}

export default ReviewItem;
